import React from 'react';

import MiniMwd from '@/apps/mwd-v2/components/MiniMwd/MiniMwd';
import { AcceptConflictDialogData } from '@/apps/mwd-v2/state/types/ActionStore';
import { useAccepteerConflictDialog } from '@/components/dialogs/accepteerConflict/useAccepteerConflictDialog';
import { Button } from '@/components/UI/Button/Button';
import MwdDialog from '@/components/UI/Dialog/Dialog';

import styles from '@/components/UI/Dialog/Dialog.module.css';

export type AccepteerConflictDialogProps = React.ComponentProps<typeof MwdDialog> & {
  handleOpenChange: () => void;
  dialogData?: AcceptConflictDialogData[] | null;
  hideFetchToast?: boolean;
  onAccepted?: () => void;
};

export const AccepteerConflictDialog = ({
  handleOpenChange,
  dialogData,
  hideFetchToast,
  onAccepted,
  ...mwdProps
}: AccepteerConflictDialogProps) => {
  const {
    handleAccepteerConflicten,
    handleAccepteerConflictNietMeer,
    selectionHasOneAcceptedConflict,
    selectionIsAllAccepted,
  } = useAccepteerConflictDialog({
    handleOpenChange,
    onAccepted,
  });

  return (
    <MwdDialog className={styles.accepteerConflictDialogStyle} handleOpenChange={handleOpenChange} {...mwdProps}>
      <p>Selecteer hieronder de inzetten waarvan je het conflict wil markeren als geaccepteerd.</p>
      <MiniMwd dialogData={dialogData} hideFetchToast={hideFetchToast} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
        }}
      >
        <Button variant='link' onClick={handleOpenChange}>
          Annuleren
        </Button>
        {(selectionHasOneAcceptedConflict || selectionIsAllAccepted) && (
          <Button variant='destructive-outline' onClick={handleAccepteerConflictNietMeer}>
            Accepteer niet meer
          </Button>
        )}
        {!selectionIsAllAccepted && (
          <Button variant='primary' onClick={handleAccepteerConflicten}>
            Accepteer conflict
          </Button>
        )}
      </div>
    </MwdDialog>
  );
};
